module.exports = __webpack_public_path__ + "static/media/chalkboard-teacher.de713f74.svg";